<template>
  <div class="do-template">
    <div class="header">
      <div class="header-left">
        <img class="logo" src="@/assets/png/logo.png" />
      </div>
      <div class="header-middle">
        <div class="title">{{ title }}</div>
        <span class="company-name">{{ companyName }}</span>
      </div>
      <div class="header-right">
        <span class="created-date">DATE: {{ date }}</span>
      </div>
    </div>
    <div class="shipment-info">
      <div class="shipment-info-title section-title">Shipment Information</div>
      <el-row
        v-for="(row_0, row_index_0) in shipmentInfoTemplate.rows"
        :key="'row-' + row_index_0"
        class="row-0"
      >
        <el-col
          v-for="(col_0, col_index_0) in row_0.cols"
          :key="'row-' + row_index_0 + '-col-' + col_index_0"
          :span="24 * col_0.span"
          class="col-0"
        >
          <div v-if="col_0.id" class="cell">
            <div class="title" style="font-size: 14px;">{{ col_0.title }}:</div>
            <div class="content" style="font-size: 15px;">
              {{ doForm[col_0.id] }}
            </div>
          </div>
          <el-row
            v-for="(row_1, row_index_1) in col_0.rows"
            :key="
              'row-' +
              row_index_0 +
              '-col-' +
              col_index_0 +
              '-row-' +
              row_index_1
            "
            class="row-1 f-r"
          >
            <el-col
              v-for="(col_1, col_index_1) in row_1.cols"
              :key="
                'row-' +
                row_index_0 +
                '-col-' +
                col_index_0 +
                '-row-' +
                row_index_1 +
                '-col-' +
                col_index_1
              "
              :span="24 * col_1.span"
              class="col-1"
            >
              <div v-if="col_1.id" class="cell">
                <div class="title" style="font-size: 13px;">
                  {{ col_1.title }}:
                </div>
                <div class="content" style="font-size: 14px;">
                  {{ doForm[col_1.id] }}
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div class="container-info">
      <div class="container-info-title section-title">
        Container Information
      </div>
      <div class="container-info-content">
        <el-row
          v-for="(row, rowIndex) in containerInfoTemplate.rows"
          :key="'container-row-' + rowIndex"
          class="row-0"
        >
          <el-col
            v-for="(col, colIndex) in row.cols"
            :key="'container-row-' + rowIndex + '-col-' + colIndex"
            :span="24 * col.span"
            class="col-0"
            ><div class="cell">
              <div class="title" style="font-size: 14px;">{{ col.title }}:</div>
              <div class="content" style="font-size: 15px;">
                {{ doForm[col.id] }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="remark-info">
      <div class="remark-info-title section-title">Remark</div>
      <div class="remark-info-content">
        <span v-for="(item, index) in remark" :key="'remark-' + index"
          >{{ index + 1 }}. {{ item }}
        </span>
      </div>
    </div>
    <div class="other-info">
      <div class="contact-info">
        <span
          v-for="(item, index) in otherInfo.contactInfo"
          :key="'contact-' + index"
        >
          {{ item.title }}: {{ item.value }}
        </span>
      </div>
      <div class="address-info">
        <span>
          {{ otherInfo.addressInfo.title }}:
          {{ otherInfo.addressInfo.value }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
// model
import { companyInfo } from '@/core/models/do'

export default {
  name: 'DoTemplate',
  props: {
    shipmentInfoTemplate: {
      type: Object,
      required: true
    },
    containerInfoTemplate: {
      type: Object,
      required: true
    },
    doForm: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      title: 'PICK-UP & DELIVERY INSTRUCTION',
      companyName: 'Rigel International Inc',
      date: new Date().toLocaleDateString('en-US'),

      remark: [
        'ALL ABOVE INFORMATION IS RELAYED TO YOU FROM OUR OVERSEAS BY OUR COMPANY ACTING AS THEIR RECEIVING OFFICE.',
        'THE RELEASE OF ABOVE FREIGHT WILL ONLY BE 24-72 HRS AFTER / UPON THE RECEIPT OF YOUR FULL PAYMENT OF ABOVE CHARGES AND PROPERLY ENDOSED BILL OF LADING. PLEASE MAKE PAYMENT PAYBLE TO CITY OCEAN INTERNATIONAL INC.',
        'PLEASE ARRANGE PICK UP OF YOUR FREIGHT AND RETURN OF CONTAINER WITHIN THE FREE-TIME. OTHERWISE YOU SHALL BE RESPONSIBLE FOR ANY CHARGES TO BE IMPOSED BY CARRIER OR WAREHOUSE.',
        'PLEASE CALL TERMINAL TO CONFIRM DATE/LOCATION OF CARGO AVAILABILITY PRIOR AS CHANGES MAY OCCUR BEYOND OUR CONTROL.',
        'THE IMPORTERS OR THEIR CUSTOMS BROKER ARE RESPONSIBLE FOR CONTACTING WITH THE US. CUSTOMS FOR THE EXAM RELATED ISSUES AND PAYING THE FEES',
        'EFFCTIVE ON 7/23/05, ALL IMPORTERS ARE REQUIRED TO PAY TMF CHGES $50/20 & $100/40 OR H AT LONG'
      ],
      otherInfo: {
        contactInfo: [
          {
            title: 'Customer Service',
            id: 'customerService',
            value: companyInfo.customerService
          },
          { title: 'Email', id: 'email', value: companyInfo.email },
          { title: 'TEL', id: 'tel', value: companyInfo.tel }
        ],
        addressInfo: {
          title: 'Address',
          id: 'address',
          value: companyInfo.address
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.do-template {
  width: 21cm !important;
  height: 29.8cm !important;

  .content {
    min-height: 25px;
    white-space: pre-line;
    font-weight: bold;
  }

  .header {
    @extend .f-r-hsb;

    border: solid;
    border-bottom: none;

    .header-left {
      margin-left: 20px;

      @extend .f-c-c-c;

      .logo {
        height: 50px;
        width: 50px;
      }
    }

    .header-middle {
      @extend .f-c-c-c;

      margin-left: 8%;

      .title {
        font-size: 29px;
        font-weight: bold;
        margin: 20px 0;
      }
    }

    .header-right {
      margin-right: 20px;

      @extend .f-c;

      justify-content: end;
    }
  }

  .section-title {
    background-color: #afb3b0;
    font-weight: bold;
    text-align: center;
    padding: 4px;
  }

  .cell {
    border: solid;
    border-right: none;
    border-bottom: none;
    height: 100%;
    padding: 4px;
  }

  .shipment-info {
    border-right: solid;

    .shipment-info-title {
      border-top: solid;
      border-left: solid;
    }

    .row-0 {
      width: 100%;

      @extend .f-r;

      .col-0 {
        @extend .f-c;

        justify-content: space-even;

        .row-1 {
          height: 100%;

          .col-1 {
            overflow: hidden;
          }
        }
      }
    }
  }

  .container-info {
    border: solid;
    border-bottom: none;
    border-left: none;

    .container-info-title {
      border-left: solid;
    }

    .container-info-content {
      @extend .f-c;

      .container-info-item {
        gap: 10px;

        .container-info-item-title {
          min-width: 220px;

          @extend .f-r;

          justify-content: end;
        }

        .container-info-item-content {
          max-width: 60%;
          word-wrap: break-word;
        }
      }
    }
  }

  .remark-info {
    border: solid;
    border-bottom: none;

    .remark-info-content {
      padding: 4px;
      font-size: 14px;

      @extend .f-c;
    }
  }

  .other-info {
    font-size: 14px;
    border: solid;
    padding: 4px;

    .contact-info {
      @extend .f-r;

      gap: 30px;
    }
  }
}
</style>
